<template>
  <div>
    <vm-table
        ref="vmTable"
        height="68vh"
        :filter.sync="filter"
        module="basic"
        url="applications/todo/my">
      <template slot="adSearch">
        <div class="vm-search">
          <el-radio-group v-model="filter.isread" style="margin-top: -20px" @change="getList(1)">
            <el-radio label="">全部</el-radio>
            <el-radio label="1">已读</el-radio>
            <el-radio label="0">未读</el-radio>
          </el-radio-group>
          <vm-search label="">
            <el-input v-model.trim="filter.filter" placeholder="请输入关键字查询" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="sequID" label="主键" width="100" align="center"/>
      <el-table-column prop="billNO" label="资料名称">
        <template slot-scope="scope">
          <a @click="gotoApprove(scope.row)">{{scope.row.billNO}}</a>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="fileType" label="资料类型" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fileType === 10">产品样本</span>
          <span v-if="scope.row.fileType === 20">产品介绍</span>
          <span v-if="scope.row.fileType === 30">说明书</span>
          <span v-if="scope.row.fileType === 40">操作手册</span>
          <span v-if="scope.row.fileType === 50">型式试验证书</span>
          <span v-if="scope.row.fileType === 60">产品认证证书</span>
          <span v-if="scope.row.fileType === 70">配置表</span>
          <span v-if="scope.row.fileType === 80">配置工具</span>
          <span v-if="scope.row.fileType === 90">其他</span>
        </template>
      </el-table-column>
      <el-table-column prop="releaseType" label="发布类型" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.releaseType === 10">新发布</span>
          <span v-if="scope.row.releaseType === 20">版本升级</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="文件类型" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 128">文件</span>
          <span v-if="scope.row.type === 16">文件夹</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="descrpt" label="节点名称" width="120" align="center"/>
      <el-table-column prop="creatorName" label="制单人" width="100" align="center"/>
      <el-table-column prop="createdTime" label="上节点处理时间" width="160" align="center"/>
      <el-table-column prop="submitDate" label="创建时间" width="160" align="center"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    components: { VmTable, VmSearch },
    data() {
      return {
        filter: {
          billType: 25,
          isread: "",
          filter: "",
        },
      };
    },

    mounted() {
      this.getList(1);
    },

    methods: {
      // 获取待办列表
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      // 跳转审批界面
      gotoApprove(row) {
        this.$router.push({
          path: "/approval",
          query: {
            billType: 25,
            billId: row.billID,
            sequId: row.sequID,
            $tabName: "审批_" + row.billNO,
          },
        });
      },
    },
  };
</script>
